module.exports = __webpack_public_path__ + "img/plusfl_5x.47346b14.png";